import { Navigate } from 'react-router-dom';
import { supportedLangs, defaultLang } from '@/i18n';

function detectLanguage() {
  const saved = localStorage.getItem('i18nextLng');
  if (saved && supportedLangs.includes(saved)) return saved;

  const browserLangs = navigator.languages || [navigator.language || ''];
  for (const raw of browserLangs) {
    const code = raw.split('-')[0].toLowerCase();
    if (supportedLangs.includes(code)) return code;
  }

  return defaultLang;
}

export default function LanguageRedirect({ suffix = '' }) {
  return <Navigate to={`/${detectLanguage()}${suffix}`} replace />;
}
